module.exports = __webpack_public_path__ + "img/lukasz-szmigiel-dAgtO5H8cXg-unsplash.0143cda6.jpg";